"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatDate_1 = __importDefault(require("./formatDate"));
var getDefaultFormat_1 = require("../../defaults/getDefaultFormat");
var getTableDisplayContent = function (data, entity, crudeConfig, column, onlyPositiveBooleans, entityReferencePreviews, crudeLabels, thumbnailData, maxThumbnails) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var content = data;
    // previewStrings integrieren
    content = (entityReferencePreviews && ((_a = column.outgoingReference) === null || _a === void 0 ? void 0 : _a.targetEntity) && entityReferencePreviews[(_b = column.outgoingReference) === null || _b === void 0 ? void 0 : _b.targetEntity]) ? entityReferencePreviews[(_c = column.outgoingReference) === null || _c === void 0 ? void 0 : _c.targetEntity][content] : content;
    var dateTime = data;
    if (column.columnType === 'Time') {
        content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.time);
    }
    if (column.columnType === 'Date') {
        content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.date);
    }
    if (column.columnType === 'DateTime') {
        content = formatDate_1.default(dateTime, getDefaultFormat_1.Format.dateTime);
    }
    if (column.columnType === 'Boolean') {
        if (onlyPositiveBooleans) {
            content = data ? '<span style="margin:0px 5px">&#9745;</span>' : '';
        }
        else {
            content = data ? '<span style="margin:0px 5px">&#9745;</span>' : '<span style="margin:0px 5px">&#9744;</span>';
        }
    }
    if (column.columnType === 'Enum') {
        var columnLabels = (_e = (_d = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _d === void 0 ? void 0 : _d.entity[entity]) === null || _e === void 0 ? void 0 : _e.columns;
        content = columnLabels ? (_g = (_f = columnLabels[column.name]) === null || _f === void 0 ? void 0 : _f.options[data]) === null || _g === void 0 ? void 0 : _g.title : data;
    }
    if (column.columnType === 'Files' && thumbnailData) {
        var files = thumbnailData || [];
        var fileContent_1 = '';
        var fileCounter_1 = 0;
        var maxLength_1 = maxThumbnails || files.length;
        (_h = thumbnailData[column.name]) === null || _h === void 0 ? void 0 : _h.map(function (element) {
            if (fileCounter_1 < maxLength_1) {
                fileCounter_1 += 1;
                fileContent_1 += thumbnailData && thumbnailData[column.name] ? "<img style=\"margin:3px;\" src=\"data:image;base64, " + element + "\">" : '';
            }
        });
        content = fileContent_1;
    }
    return content;
};
var getListLabelTemplateContent = function (template, crudeSchema, joinEntitySchema, data, entity, crudeConfig, onlyPositiveBooleans, crudeLabels, entityReferencePreviews, joinContext, thumbnailData, maxThumbnails) {
    var listLabel;
    var joinEntityTemplate = template;
    // wenn ein Template hinterlegt ist, wird die preview damit überschrieben
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    Object.keys(data).forEach(function (dataKey) {
        if (data[dataKey]) {
            var content_1 = data[dataKey];
            entitySchema && entitySchema.columns.map(function (column) {
                if (column.name === dataKey) {
                    content_1 = getTableDisplayContent(data[dataKey], entity, crudeConfig, column, onlyPositiveBooleans, entityReferencePreviews, crudeLabels, thumbnailData, maxThumbnails);
                }
            });
            joinEntityTemplate = joinEntityTemplate && joinEntityTemplate.replace("{{data:" + dataKey + "}}", content_1);
        }
    });
    if (joinContext && Object.keys(joinContext).length > 0) {
        Object.keys(joinContext).forEach(function (joinContextKey) {
            var content = joinContext ? joinContext[joinContextKey] : '';
            joinEntitySchema && joinEntitySchema.columns.map(function (joinColumn) {
                if (joinColumn.name === joinContextKey) {
                    content = getTableDisplayContent(joinContext && joinContext[joinContextKey], entity, crudeConfig, joinColumn, onlyPositiveBooleans, entityReferencePreviews, crudeLabels, thumbnailData, maxThumbnails);
                }
            });
            joinEntityTemplate = joinContext ? joinEntityTemplate && joinEntityTemplate.replace("{{joinContext:" + joinContextKey + "}}", content) : joinEntityTemplate;
        });
    }
    else {
        var startExpression = joinEntityTemplate.indexOf('{{joinContext:');
        var endExpression = joinEntityTemplate.indexOf('}}');
        joinEntityTemplate = (startExpression >= 0 && endExpression >= 0) ? joinEntityTemplate.substring(0, startExpression) + joinEntityTemplate.substring(endExpression + 2, joinEntityTemplate.length) : joinEntityTemplate;
    }
    // wenn values nicht ersetzt werden können, gehen wir davon aus, dass das Template fehlerhaft ist > preview wird nicht überschrieben
    if (joinEntityTemplate.indexOf('{{') < 0) {
        listLabel = joinEntityTemplate;
    }
    // <script> / <iframe> tags entfernen
    listLabel && listLabel.replace('<script>', '').replace('<iframe>', '').replace('</script>', '').replace('</iframe>', '');
    return listLabel;
};
exports.default = getListLabelTemplateContent;
